import React, {Component} from "react";
import {observer, inject} from "mobx-react";
import {Popover} from "antd";
import "./WordCount.css";

@inject("content")
@observer
class WordCount extends Component {
  // 计算字数统计
  calculateStats = (text) => {
    if (!text) {
      return {
        chineseChars: 0,
        totalChars: 0,
        paragraphs: 0,
        words: 0,
      };
    }

    // 中文字符数（包括中文标点）
    const chineseChars = (text.match(/[\u4e00-\u9fa5]/g) || []).length;

    // 总字符数（包括所有字符）
    const totalChars = text.length;

    // 段落数（按空行分割）
    const paragraphs =
      text.split(/\n\s*\n/).filter((p) => p.trim().length > 0).length || (text.trim().length > 0 ? 1 : 0);

    // 英文单词数
    const words = (text.match(/[a-zA-Z]+/g) || []).length;

    return {
      chineseChars,
      totalChars,
      paragraphs,
      words,
    };
  };

  // 估算阅读时间（按每分钟300字计算）
  estimateReadingTime = (chineseChars) => {
    if (chineseChars === 0) return 0;
    const minutes = Math.ceil(chineseChars / 300);
    return minutes;
  };

  render() {
    const {content} = this.props.content;
    const stats = this.calculateStats(content);
    const readingTime = this.estimateReadingTime(stats.chineseChars);

    const detailContent = (
      <div className="word-count-detail">
        <div className="word-count-item">
          <span className="word-count-label">中文字数：</span>
          <span className="word-count-value">{stats.chineseChars.toLocaleString()}</span>
        </div>
        <div className="word-count-item">
          <span className="word-count-label">总字符数：</span>
          <span className="word-count-value">{stats.totalChars.toLocaleString()}</span>
        </div>
        <div className="word-count-item">
          <span className="word-count-label">段落数：</span>
          <span className="word-count-value">{stats.paragraphs}</span>
        </div>
        <div className="word-count-item">
          <span className="word-count-label">英文单词：</span>
          <span className="word-count-value">{stats.words}</span>
        </div>
        <div className="word-count-divider" />
        <div className="word-count-item">
          <span className="word-count-label">预计阅读：</span>
          <span className="word-count-value reading-time">
            {readingTime === 0 ? "不到 1 分钟" : `约 ${readingTime} 分钟`}
          </span>
        </div>
      </div>
    );

    return (
      <Popover content={detailContent} title="字数统计" trigger="hover" placement="bottomRight">
        <section className="word-count-display">
          <span className="word-count-main">{stats.chineseChars.toLocaleString()} 字</span>
          {readingTime > 0 && <span className="word-count-time">· 约 {readingTime} 分钟</span>}
        </section>
      </Popover>
    );
  }
}

export default WordCount;
